
import Loader from "react-loader-spinner";
function NotificationLoader() {
    return (
      <div className="d-flex align-items-center justify-content-center h-75vh">
        <Loader
          type="ThreeDots"
          color="#2d207d"
          height={40}
          width={40}
          style={{
            textAlign: "center",
            marginBottom: "50px",
          }}
        />
      </div>
    );
  }
  export default NotificationLoader;